import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';

import { queryMap, queryKeys } from '@simple-city/service-graphql-schemas';

import * as actions from '../../actions';

import VenueSelector from '../../components/Venues/VenueSelector';

const mapStateToProps = ({ auth: { profile }, venue }) => ({ profile, venue });

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

const withData = graphql(queryMap[queryKeys.Q_VENUES])(VenueSelector);

const VenueSelectorContainer = connect(mapStateToProps, mapDispatchToProps)(withData);

export default VenueSelectorContainer;



// WEBPACK FOOTER //
// ./src/containers/Venues/VenueSelectorContainer.js